import React from "react";
import DesktopEducationEntry from "./contentCards/desktopEducationCard";
import { educations } from "../../data";

const DesktopEducation = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="py-2"
      >
        Education & Training
      </div>
      {educations.map((edu) => (
        <DesktopEducationEntry key={edu.id} education={edu} />
      ))}
    </div>
  );
};

export default DesktopEducation;
